import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "card-wrapper"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "buttons-container" }

import ResumeBase from "@/Layouts/ResumeBase/ResumeBase.vue";
import AppButton from "@/components/Common/AppButton/AppButton.vue";
import PreviewCard from "@/components/Resume/PreviewCard/PreviewCard.vue";
import { useResumeStore } from "@/store";
import { onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { onIonViewDidEnter } from "@ionic/vue";
import {
  convertToMonthYear,
  sortLicences,
  focusOnMainContent,
} from "@/helpers";

export default /*@__PURE__*/_defineComponent({
  __name: 'ResumeLicences',
  setup(__props) {

const resumeStore = useResumeStore();
const router = useRouter();
const route = useRoute();

onIonViewDidEnter(() => {
  focusOnMainContent(route?.meta?.mainContentId);
});

onMounted(async () => {
  if (!resumeStore.resumeId) {
    await resumeStore.requestResume();
    if (!resumeStore.resumeId) {
      await resumeStore.createResume();
    }
  }
});

function addLicence() {
  resumeStore.initLicenceForm();
  router.push({
    name: "ResumeLicenceDetail",
    params: { id: "new" },
  });
}

function editLicences(id: string) {
  resumeStore.initLicenceForm(id);
  router.push({
    name: "ResumeLicenceDetail",
    params: { id: id },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ResumeBase, {
    breadcrumbs: [
      {
        route: 'licences',
        label: _ctx.$t('resume.breadcrumbs.licences'),
      },
    ],
    mainContentId: "resume-licences-main-content",
    skipOnRouteBeforeLeave: true
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("resume.licences.title")), 1)
    ]),
    description: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t("resume.licences.description")), 1)
    ]),
    "main-content": _withCtx(() => [
      (_unref(resumeStore).isResumeLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (item) => {
              return _createElementVNode("div", {
                class: "card-item",
                key: item
              }, [
                _createVNode(PreviewCard, { isLoading: true })
              ])
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sortLicences)(_unref(resumeStore)?.resume?.licences), (licence) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "card-item",
                key: licence.id
              }, [
                _createVNode(PreviewCard, {
                  id: licence.id,
                  title: licence.name,
                  isLoading: _unref(resumeStore).isResumeLoading,
                  "data-test": "preview-card",
                  "button-text": _ctx.$t('resume.licences.editButton'),
                  onClick: ($event: any) => (editLicences(licence.id))
                }, _createSlots({
                  metadata: _withCtx(() => [
                    _createElementVNode("p", null, _toDisplayString(licence.issuer), 1),
                    _createElementVNode("p", null, [
                      _createTextVNode(_toDisplayString(_unref(convertToMonthYear)(licence.issueDate, _ctx.$t)) + " ", 1),
                      (licence.issueDate && licence.expiryDate)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " - "))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_unref(convertToMonthYear)(licence.expiryDate, _ctx.$t)), 1)
                    ])
                  ]),
                  _: 2
                }, [
                  (licence.description)
                    ? {
                        name: "description",
                        fn: _withCtx(() => [
                          _createElementVNode("p", null, _toDisplayString(licence.description), 1)
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["id", "title", "isLoading", "button-text", "onClick"])
              ]))
            }), 128))
          ])),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(AppButton, {
          size: "default",
          type: "primary",
          label: _ctx.$t('resume.licences.addButton'),
          ariaLabel: _ctx.$t('resume.licences.addButton'),
          "data-test": "add-btn",
          onClick: addLicence,
          width: "100%",
          showLoadingSkeleton: _unref(resumeStore).isResumeLoading
        }, null, 8, ["label", "ariaLabel", "showLoadingSkeleton"]),
        _createVNode(AppButton, {
          size: "default",
          type: "secondary",
          label: _ctx.$t('resume.licences.returnButtonText'),
          ariaLabel: _ctx.$t('resume.licences.returnButtonText'),
          "data-test": "return-btn",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'ResumeOverview' }))),
          width: "100%",
          showLoadingSkeleton: _unref(resumeStore).isResumeLoading
        }, null, 8, ["label", "ariaLabel", "showLoadingSkeleton"])
      ])
    ]),
    "resume-helper": _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
    _: 1
  }, 8, ["breadcrumbs"]))
}
}

})